<template>
  <div v-if="isMultiLanguageEnabled" class="dropdown is-hoverable is-right">
    <div class="dropdown-trigger">
      <button class="button is-light is-small" aria-haspopup="true" aria-controls="language-dropdown">
        <span class="icon is-small">
          <i class="fa fa-globe"></i>
        </span>
        <span>{{ currentLanguage.flag }} {{ currentLanguage.code.toUpperCase() }}</span>
        <span class="icon is-small">
          <i class="fa fa-angle-down"></i>
        </span>
      </button>
    </div>
    <div class="dropdown-menu" id="language-dropdown" role="menu">
      <div class="dropdown-content">
        <a
          v-for="language in availableLanguages"
          :key="language.code"
          class="dropdown-item"
          href="#"
          @click.prevent="changeLanguage(language.code)"
          :class="{ 'is-active': currentLanguage.code === language.code }"
        >
          {{ language.flag }} {{ language.name }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguageSelector',
  data () {
    return {
      availableLanguages: [
        { code: 'en', name: 'English', flag: '🇺🇸' },
        { code: 'it', name: 'Italiano', flag: '🇮🇹' },
        { code: 'pt', name: 'Português', flag: '🇵🇹' }
      ],
      isMultiLanguageEnabled: true
    }
  },
  computed: {
    currentLanguage () {
      const currentLang = this.availableLanguages.find(lang => lang.code === this.$i18n.locale)
      if (currentLang) {
        return currentLang
      }
      // Fallback to i18n fallback locale
      return this.availableLanguages.find(lang => lang.code === this.$i18n.fallbackLocale) || this.availableLanguages[0]
    }
  },
  methods: {
    changeLanguage (languageCode) {
      this.$i18n.locale = languageCode
      // Store the selected language in localStorage
      localStorage.setItem('selectedLanguage', languageCode)
    },
    detectBrowserLanguage () {
      const browserLang = navigator.language || navigator.userLanguage
      const langCode = browserLang.split('-')[0] // Get language code (e.g., 'en' from 'en-US')

      // Check if the detected language is available
      const availableLang = this.availableLanguages.find(lang => lang.code === langCode)
      if (availableLang) {
        return langCode
      }

      // Fallback to i18n fallback locale if browser language is not available
      return this.$i18n.fallbackLocale
    },
    initializeLanguage () {
      // Check if user has a saved language preference
      const savedLanguage = localStorage.getItem('selectedLanguage')

      if (savedLanguage && this.availableLanguages.find(lang => lang.code === savedLanguage)) {
        this.$i18n.locale = savedLanguage
      } else {
        // Use browser language detection
        const detectedLanguage = this.detectBrowserLanguage()
        this.$i18n.locale = detectedLanguage
        localStorage.setItem('selectedLanguage', detectedLanguage)
      }
    }
  },
  mounted () {
    if (this.isMultiLanguageEnabled) {
      this.initializeLanguage()
    }
  }
}
</script>

<style scoped>
.dropdown-item.is-active {
  background-color: #f5f5f5;
  color: #3273dc;
}
</style>



// WEBPACK FOOTER //
// src/components/LanguageSelector.vue